
import NotFooterLayout from "layouts/NotFooterLayout";
import ManageAgent from "components/ManageAgent";


function ManageAgentPage() {

  return (
    <>
    {/* <ProductLayout namePage="ตัวแทน" footerComponent={<FooterAgent />}  >
      <div className="layout-content">
       <ManageAgent />
        </div>
    </ProductLayout> */}
      <NotFooterLayout namePage="ฐานลูกค้า" >
        <div className="layout-content">
          <ManageAgent />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default ManageAgentPage;